import React from "react";
import S from './DescriptionEvent.module.scss';
import backgroundForCompany1 from "../../shared/assets/images/backgroundForCompany1.png";
import backgroundForCompany2 from "../../shared/assets/images/backgroundForCompany2.png";
import logistic from "../../shared/assets/images/imgLogistic.png";
import logistic3 from "../../shared/assets/images/imgLogistic3.png";

interface Props {
    id: number;
}

export const DescriptionEvent = ({id}: Props) => {
    return (
        <div className={S.contentDiv}>
            <div className={S.backgroundForCompany1}>
                {id === 5 ? (
                    <img src={logistic} alt="logistic"/>
                ) : (
                    <img src={backgroundForCompany1} alt="backgroundForCompany1"/>
                )}
            </div>
            {id === 1 ? (
                <div className={S.content}>
                    <div className={S.mainText}>
                        <span>Закрытый формат и ограниченное количество мест</span> — участие по предварительной
                        регистрации, только для профильной аудитории.
                    </div>
                    <div className={S.mainText}>
                        <span>«ЭВОФОРУМ» и группа компаний Северсталь при поддержке Экспертной сети Северстали приглашают руководителей и профильных специалистов промышленных предприятий, а также поставщиков технологических и ИТ-решений на закрытое отраслевое мероприятие 2026 года.</span>
                    </div>
                    <div className={S.mainText}>
                        <span>EVO.INDUSTRY-2026 «Цифровизация промышленности»</span> — ключевая деловая площадка для
                        тех, кто формирует будущее промышленной цифровизации: производство, данные, ИИ и ИТ-архитектура
                        в едином контуре обсуждения.
                    </div>
                    <div className={S.mainText}>
                        Это не конференция о трендах. Это дни практики: реальные кейсы с цифрами экономии — <span>1,8 млрд
                        ₽/год на стане 2000, 4,2 млрд ₽ экономии на предиктивном обслуживании подвижного состава, 87%
                        точности прогноза отказов, 99,2% автоматической разбраковки трубы</span> — и разбор ошибок, от
                        стратегии до конкретного инструмента.
                    </div>
                    <div className={S.mainText}>
                        Форум проходит в закрытом формате с ограниченным количеством участников: в зале только
                        профильные специалисты и лица, принимающие решения, — без случайной публики. Это гарантирует
                        глубину дискуссий и ценность каждого контакта.
                    </div>
                    <div className={S.mainText}>
                        <span>Тематика:</span> цифровизация промышленности, промышленный искусственный интеллект,
                        импортонезависимая ИТ-архитектура, цифровые двойники, MES и предиктивное обслуживание.
                    </div>
                    <div className={S.mainText}>
                        <span>Цель мероприятия:</span> Межотраслевой обмен опытом по внедрению лучших практик, ключевым
                        аспектам эффективного управления процессами цифровизации, использованию современных цифровых
                        инструментов и технологий оптимизации затрат в ключевых отраслях экономики —
                        горно-металлургический комплекс, топливно-энергетический и нефтехимический сектор,
                        машиностроение.
                    </div>
                    <div className={S.titleText}>Неформальный нетворкинг</div>
                    <div className={S.paragraphText}>
                        <div className={S.mainText}>• <span>Закрытый круг профессионалов.</span> Формат мероприятия —
                            закрытый: в зале только профильные специалисты и ЛПР, без «случайной» публики. Это
                            обеспечивает глубину дискуссий, доверительный разговор и полезные контакты. Кофе-брейки и
                            обеды в течение всех дней форума — дополнительное время для неформального общения с
                            коллегами и поставщиками.
                        </div>
                        <div className={S.mainText}>• <span>Вечерний фуршет.</span> Неформальный нетворкинг, где
                            завязываются лучшие деловые связи.
                        </div>
                    </div>
                    <div className={S.titleText}>Промышленный тур на Череповецкий металлургический комбинат</div>
                    <div className={S.paragraphText}>
                        <div className={S.mainText}>• посещение Центра металлургической промышленности;</div>
                        <div className={S.mainText}>• смотровая галерея доменной печи №5 «Северянка» и самого
                            производительного в российской металлургии стана 2000.
                        </div>
                    </div>
                    <div className={S.mainText}>Доменная печь №5 «Северянка» на момент пуска и далее на протяжении почти
                        20 лет оставалась самой большой печью в мире. Высота агрегата — 105 метров, полный объём — более
                        5,5 тысяч кубометров. В силу масштабов домна-гигант занесена в книгу рекордов Гиннесса. Её
                        текущая производительность — 4,2 миллиона тонн чугуна в год. В 2023 году печь выпустила 35%
                        чугуна ЧерМК. Остеклённая смотровая галерея, оснащённая интерактивными элементами, размещена на
                        высоте 14 метров над литейным двором ДП-5.
                    </div>
                    <div className={S.titleText}>Заявки на участие в экскурсии направлять: <a
                        href="mailto:a.chaudri@evoforum.ru">a.chaudri@evoforum.ru</a></div>
                </div>
            ) : (
                id === 2 ? (
                    <div className={S.content}>
                        <div className={S.mainText}><span>В Москве прошёл международный форум EVO.INDUSTRY–2025 | ЦИФРОВИЗАЦИЯ 4.0: ЭНЕРГЕТИКА • ТОиР • ЭКОЛОГИЯ</span>
                        </div>
                        <div className={S.mainText}>
                            В Москве завершился международный форум <span>EVO.INDUSTRY–2025 | Цифровизация 4.0</span>,
                            ставший одной
                            из ключевых дискуссионных площадок страны в области цифровой трансформации промышленности,
                            энергетики, логистики и экологии.
                        </div>
                        <div className={S.mainText}>
                            Мероприятие
                            прошло <span>28–29 октября в Китайском деловом центре «Парк Хуамин»</span> при <span>официальном
                            патронаже Торгово-промышленной палаты РФ</span> и собрало представителей ведущих российских
                            компаний и ведомств.
                        </div>
                        <div className={S.mainText}>
                            Форум прошёл <span>при патронаже Торгово-промышленной палаты Российской Федерации</span>,
                            собрав
                            представителей ведущих российских компаний и ведомств: <span>Газпром нефть, СИБУР, Северсталь,
                            ЕВРАЗ, Норникель, РОСАТОМ, Киберсталь,</span> а также <span>Ассоциацию Больших Данных, РУССОФТ, АРВЭ, АНО
                            «Цифровая Экономика», АЛРИИ, РГО</span> и многих других.
                        </div>
                        <div className={S.mainText}>
                            В программе форума — <span>пленарная сессия и восемь отраслевых тематических блоков</span>,
                            охватывающих
                            цифровизацию в энергетике, производстве, ТОиР, экологии и безопасности.
                        </div>
                        <div className={S.mainText}>
                            Представители <span>более 160 компаний</span> посетили форум. Всего за два дня состоялось
                            более <span>60
                            докладов</span>, объединивших лучшие практики, новые технологии и стратегические решения
                            российских
                            компаний.
                        </div>
                        <div className={S.mainText}><span>🎤 Ключевые спикеры пленарной сессии:</span></div>
                        <div className={S.paragraphText}>
                            <div className={S.mainText}>• <span>Вотяков Сергей Евгеньевич</span>, председатель
                                Координационного совета
                                ассоциаций МСП в
                                сфере ИИ, старший директор по взаимодействию с органами власти PIX Robotics, член
                                Правления НП РУССОФТ — «Развитие искусственного интеллекта и роботизации в
                                промышленности».
                            </div>
                            <div className={S.mainText}>• <span>Кананыкин Илья Григорьевич</span>, директор Ассоциации
                                Больших Данных — «Опыт
                                работы с данными в России. Экспертиза отраслей, достигших цифровой зрелости».
                            </div>
                            <div className={S.mainText}>• <span>Булатов Николай Владимирович</span>, директор
                                направления энергоёмких производств Фонда «Сколково» (Группа ВЭБ.РФ) — «Инструменты
                                государственной поддержки разработчиков и заказчиков российских решений для
                                промышленности».
                            </div>
                            <div className={S.mainText}>• <span>Плешков Алексей</span>, независимый эксперт по ИБ,
                                эксперт BISA - «Национальные приоритеты в кибербезопасности и цифровой суверенитет».
                            </div>
                            <div className={S.mainText}>• <span>Мостовщиков Алексей</span>, президент Международной
                                ассоциации промышленников и предпринимателей «МОСТ», член РСПП — «Цифровое управление
                                строительством Mstroy».
                            </div>
                            <div className={S.mainText}>• <span>Сурова Надежда</span>, пдиректор Центра компетенций
                                «Цифровая экономика», член совета по цифровой экономике Совета Федерации ФС РФ —
                                «Государственные программы РФ в сфере цифровизации».
                            </div>
                        </div>
                    </div>
                ) : (
                    id === 3 ? (
                        <div className={S.content}>
                            <div className={S.mainText}><span>В Череповце прошёл Всероссийский форум ТОиР EVO.INDUSTRY–2026</span>
                            </div>
                            <div className={S.mainText}>
                                В Череповце завершился закрытый отраслевой форум <span>«EVO.INDUSTRY-2026 • Всероссийский
                                форум ТОиР»</span> организованный <span>ООО «Эвофорум»</span>.
                            </div>
                            <div className={S.mainText}>
                                Совместно с экспертной
                                сетью <span>«Техническое обслуживаине и ремонты»</span> компаний <span>«Северсталь», «Севергрупп»</span>.
                            </div>
                            <div className={S.mainText}>
                                Мероприятие прошло <span>7–8 апреля</span> на базе <span>«Торово»</span> и собрало
                                представителей ведущих
                                российских компаний горно-металлургического комплекса, топливно-энергетического сектора
                                и машиностроения — руководителей и специалистов служб технического обслуживания и
                                ремонта, надёжности и эксплуатации оборудования.
                            </div>
                            <div className={S.mainText}><span>Форум открыл приветственным словом начальник управления ТОиР ПАО «Северсталь» Золотов Андрей Вячеславович.</span>
                            </div>
                            <div className={S.mainText}>В работе форума приняли участие представители ведущих российских
                                компаний и организаций: <span>Северсталь, Северсталь-инфоком, Северсталь Метиз, ЕВРАЗ (НТМК,
                                ЗСМК), Михайловский ГОК им. А.В. Варичева, Свеза-Лес, Экорусметалл, Лаборатория
                                Касперского, НТЦ АРГУС, ТСТ (Технические системы и технологии), ЭКСОЙЛ, АГК, Доринг
                                Сервис Rexroth, ОТ-ОЙЛ (Атоллис), АО «МЦД», НИИОГР, ИГД УрО РАН, ЭРОСТ Груп</span> и
                                многие
                                другие.
                            </div>
                            <div className={S.mainText}>
                                <span>В программе форума</span> — стратегическая сессия и тематические сессии,
                                охватывающие
                                комплексный подход к управлению ремонтами и предиктивное обслуживание: цифровизацию,
                                автоматизацию и применение ИИ-инструментов. Завершился форум панельной дискуссией
                                «Развитие функции ТОиР в отраслевых компаниях».
                            </div>
                            <div className={S.mainText}>
                                Всего за два дня состоялось <span>более 50 докладов</span> и <span>экспертных выступлений</span>,
                                объединивших
                                лучшие практики, новые технологии и стратегические решения российских компаний. Первый
                                день форума завершился приветственным ужином для участников.
                            </div>
                            <div className={S.mainText}>
                                <span>🎤 Ключевые спикеры стратегической сессии:</span>
                            </div>
                            <div className={S.paragraphText}>
                                <div className={S.mainText}>• <span>Фотькин Дмитрий Владимирович</span>, руководитель
                                    группы Северсталь-инфоком — Портфель ИТ-решений «Ремонты»: от цифровизации ремонтов
                                    к интеллектуальной надёжности.
                                </div>
                                <div className={S.mainText}>• <span>Лезов Илья Владимирович</span>, старший менеджер по
                                    сопровождению ключевых корпоративных проектов АО «Лаборатория Касперского» —
                                    Применение искусственного интеллекта в практических задачах.
                                </div>
                                <div className={S.mainText}>• <span>Булахов Александр Львович</span>, директор по
                                    развитию Доринг Сервис Rexroth — Качественный ремонт гидравлического оборудования
                                    Bosch Rexroth/Parker.
                                </div>
                            </div>
                            <div className={S.mainText}>
                                Второй день закончился панельной дискуссией: <span>«Развитие функции ТОиР в отраслевых компаниях»</span>
                            </div>
                            <div className={S.mainText}>
                                Руководители ремонтных служб отраслевых компаний обсудили приоритетные направления для
                                функции ТОиР на 2026 год, инструменты достижения поставленных целей, отличия
                                целеполагания текущего года от прошлых лет, а также проекты развития и ожидаемую отдачу
                                от решений в среднесрочной и долгосрочной перспективе.
                            </div>
                        </div>
                    ) : (
                        id === 4 ? (
                            <div className={S.content}>
                                <div className={S.mainText}><span>В Череповце прошёл Всероссийский форум энергетиков EVO.INDUSTRY–2026</span>
                                </div>
                                <div className={S.mainText}>
                                    В Череповце завершился закрытый отраслевой форум <span>«EVO.INDUSTRY-2026 • Всероссийский
                                    форум энергетиков»</span>, организованный экспертной сетью «Энергетика и экология»
                                    компаний <span>«Северсталь» и «Севергрупп»</span> совместно
                                    с <span>ООО «Эвофорум»</span>.
                                </div>
                                <div className={S.mainText}>
                                    Мероприятие прошло <span>17–19 июня</span> на базе <span>«Торово»</span> и собрало
                                    представителей ведущих
                                    российских компаний горно-металлургического комплекса, топливно-энергетического
                                    сектора и машиностроения: <span>Северсталь, ЧЭАЗ, Монитор Электрик, НОРД, Норд энерджи,
                                    Сибшванк, ТЕКВЕЛ, НПП Бреслер, Группа СВЭЛ, Дорогобужкотломаш, Энергия холода,
                                    Транснефтьэнерго, Волжский абразивный завод, РТ-Развитие бизнеса, Кондор-Эко,
                                    Киберсталь, Северсталь-инфоком, Свеза-Лес, ФИНГО-КОМПЛЕКС, Лебединский ГОК,
                                    Карельский окатыш, Омегальянс, Мейнтекс, БМК СОФТ</span> и многих других.
                                </div>
                                <div className={S.mainText}>
                                    <span>
                                        Форум открыли приветственными речами  заместитель министра Минэнерго России Грабачок Евгений Петрович и заместитель генерального директора — директор прокатного производства Филиала «Российская сталь» в г. Череповце Савенков Николай Юрьевич.
                                    </span>
                                </div>
                                <div className={S.mainText}>
                                    <span>В программе форума</span> — стратегическая сессия и четыре отраслевые
                                    тематические сессии,
                                    охватывающие экологическую повестку в энергетике, цифровой энергоменеджмент и
                                    интеллектуальные системы учёта, энергоэффективность инженерных систем и
                                    собственную/распределённую генерацию, а также электробезопасность и надёжность
                                    электроснабжения. В рамках деловой программы прошли круглый стол
                                    «Электробезопасность и надёжность электроснабжения промпредприятий» и мастер-класс
                                    «Речь как инструмент стратегического лидерства в турбулентные времена».
                                </div>
                                <div className={S.mainText}>
                                    Всего за два дня деловой программы
                                    состоялось <span>более 50 докладов</span> и <span>экспертных
                                    выступлений</span>, объединивших лучшие практики, новые технологии и стратегические
                                    решения
                                    российских компаний. Третий день форума был посвящён промышленному туру на <span>Череповецкий металлургический комбинат ПАО «Северсталь»</span> и <span>экскурсии в музей
                                    комбината</span>.
                                </div>
                                <div className={S.mainText}>
                                    <span>🎤 Ключевые спикеры стратегической сессии:</span>.
                                </div>
                                <div className={S.paragraphText}>
                                    <div className={S.mainText}>• <span>Колотыгин Алексей Витальевич</span>,
                                        заместитель начальника производства по экспертной работе, руководитель ЦТР по
                                        энергетике ПАО «Северсталь» — «Энергетическая политика ПАО "Северсталь" —
                                        рекорды в повседневную жизнь».
                                    </div>
                                    <div className={S.mainText}>• <span>Баннов Антон Николаевич</span>, старший менеджер
                                        (эксперт) АБСС АО «Северсталь Менеджмент» — «Экспертная сеть "Северстали"».
                                    </div>
                                    <div className={S.mainText}>• <span>Карасев Алексей Юрьевич</span>, исполнительный
                                        директор АО «Монитор Электрик» — «Единая цифровая платформа реального времени:
                                        как сквозная автоматизация оперативно-технологических процессов повышает
                                        надёжность и эффективность управления энергосистемами».
                                    </div>
                                    <div className={S.mainText}>• <span>Козулов Алексей Олегович</span>, генеральный
                                        директор ООО «НОРД» — «Выгода работы с группой компаний полного цикла: деньги,
                                        сроки, риски заказчика».
                                    </div>
                                </div>
                                <div className={S.mainText}>
                                    Завершился форум заключительной речью <span>директора по энергетике — начальника
                                    производства энергоресурсов ПАО «Северсталь» Тихонова Вячеслава Николаевича</span>.
                                </div>
                            </div>
                        ) : (
                            id === 5 ? (
                                <div className={S.content}>
                                    <div className={S.mainText}>
                                        <span>Закрытый формат и ограниченное количество мест</span> — участие по
                                        предварительной регистрации, только для профильной аудитории.
                                    </div>
                                    <div className={S.mainText}>
                                        <span>«ЭВОФОРУМ» и группа компаний Северсталь при поддержке Экспертной сети Северстали приглашают руководителей и профильных специалистов промышленных предприятий, а также поставщиков технологических и ИТ-решений на закрытое отраслевое мероприятие 2026 года.</span>
                                    </div>
                                    <div className={S.mainText}>
                                        <span>EVO.INDUSTRY-2026 «Транспорт и логистика»</span> — ключевая деловая
                                        площадка для тех, кто управляет транспортным хозяйством промышленного
                                        предприятия: автомобильным, железнодорожным и карьерным транспортом, ремонтами и
                                        ТОиР, закупкой запчастей, шин, топлива и ТМЦ.
                                    </div>
                                    <div className={S.mainText}>
                                        Это не конференция о трендах. Это два дня практики: реальные кейсы, цифры
                                        экономии и разбор ошибок — от стратегии до конкретного инструмента.
                                    </div>
                                    <div className={S.mainText}>
                                        Форум проходит
                                        в <span>закрытом формате с ограниченным количеством участников:</span> в зале
                                        только профильные специалисты и лица, принимающие решения, — без случайной
                                        публики. Это гарантирует глубину дискуссий и ценность каждого контакта.
                                    </div>
                                    <div className={S.mainText}><span>Тематика:</span> цифровизация транспорта и
                                        логистики, управление цепями поставок, беспилотные и автономные технологии,
                                        складская логистика, оптимизация маршрутов и грузопотоков, надёжность и
                                        экономика эксплуатации техники.
                                    </div>
                                    <div className={S.mainText}><span>Цель мероприятия:</span> межотраслевой обмен
                                        опытом по внедрению лучших практик, ключевым аспектам эффективного управления
                                        процессами цифровизации транспорта и логистики, использованию современных
                                        цифровых инструментов и технологий оптимизации затрат в ключевых отраслях
                                        экономики — горно-металлургический комплекс, топливно-энергетический и
                                        нефтехемический сектор, машиностроение.
                                    </div>
                                    <div className={S.titleText}>Неформальный нетворкинг</div>
                                    <div className={S.paragraphText}>
                                        <div
                                            className={S.mainText}>• <span>Закрытый круг профессионалов.</span> Мероприятие
                                            проходит на закрытой территории — в зале и на площадке только профильные
                                            специалисты и ЛПР, без «случайной» публики. Это обеспечивает глубину
                                            дискуссий, доверительный разговор и полезные контакты. Кофе-брейки и обеды в
                                            течение всех дней форума — дополнительное время для неформального общения с
                                            коллегами и поставщиками.
                                        </div>
                                        <div className={S.mainText}>• <span>Вечерний фуршет.</span> Неформальный
                                            нетворкинг, где
                                            завязываются лучшие деловые связи.
                                        </div>
                                        <div className={S.titleText}>Промышленный тур на Череповецкий металлургический
                                            комбинат
                                        </div>
                                        <div className={S.paragraphText}>
                                            <div className={S.mainText}>• посещение Центра металлургической
                                                промышленности;
                                            </div>
                                            <div className={S.mainText}>• смотровая галерея доменной печи №5 «Северянка»
                                                и самого
                                                производительного в российской металлургии стана 2000.
                                            </div>
                                        </div>
                                        <div className={S.mainText}>Доменная печь №5 «Северянка» на момент пуска и далее
                                            на протяжении почти
                                            20 лет оставалась самой большой печью в мире. Высота агрегата — 105 метров,
                                            полный объём — более
                                            5,5 тысяч кубометров. В силу масштабов домна-гигант занесена в книгу
                                            рекордов Гиннесса. Её
                                            текущая производительность — 4,2 миллиона тонн чугуна в год. В 2023 году
                                            печь выпустила 35%
                                            чугуна ЧерМК. Остеклённая смотровая галерея, оснащённая интерактивными
                                            элементами, размещена на
                                            высоте 14 метров над литейным двором ДП-5.
                                        </div>
                                        <div className={S.titleTextLogistics}>Заявки на участие в экскурсии направлять: <a
                                            href="mailto:a.chaudri@evoforum.ru">a.chaudri@evoforum.ru</a></div>
                                    </div>
                                    <div className={S.mainText}>Три дня насыщенной деловой программы: прикладные
                                        доклады, экспертные дискуссии, выставка и вечерний фуршет. Один день —
                                        экскурсия на крупнейший металлургический комбинат ПАО «Северсталь» в
                                        Череповце: транспортная и логистическая инфраструктура гиганта в работе.
                                    </div>
                                    <div className={S.mainText}><span>Количество участников ограничено — заявки рассматриваются в порядке поступления, места бронируются по мере подтверждения участия.</span>
                                    </div>
                                </div>
                            ) : null
                        )
                    )
                )
            )}
            <div className={S.backgroundForCompany2}>
                {id === 5 ? (
                    <img src={logistic3} alt="logistic3"/>
                ) : (
                    <img src={backgroundForCompany2} alt="backgroundForCompany2"/>
                )}
            </div>
        </div>
    );
};